import React, { useState } from "react";
import {
    Dialog,
    Slide,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import { CategoriasProps, ItemCarrinho, ItemDestaque } from "../../../../Cardapio/public/CatalogoPage";
import CategoriaComponent from "./CategoriaComponent";
import ProdutosComponent from "./ProdutosComponent";
import InfoPedidoComponent from "./InfoPedidoComponent";
import { Usuario, UsuarioEnderecos } from "../../../../../provider/auth/AuthProps";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

type Props = {
    open: boolean;
    onClose: () => void;

    nomeCliente?: string;
    onChangeNomeCliente: (nome: string) => void;

    categorias: CategoriasProps[];
    categoria: string;
    onChangeCategoria: (categoria: string) => void;

    itens: ItemDestaque[];

    telefoneCliente: string;
    dadosUsuariosCadastrados: Usuario[];
    dadosUsuarioSelecionado?: Usuario;
    onChangeUserData: (usuario: Usuario) => void;
    //onChangeUsuarioSelecionado: (usuario: Usuario) => void;
    onChangeTelefone: (telefone: string) => void;

    onChangeEndereco: (endereco: UsuarioEnderecos) => void;

    tipo: string;
    onChangeTipoPedido: (tipo: string) => void;

    pedidoPara: string;
    //onChangePedidoPara: (tipo: string) => void;

    formasPagamento: any[];
    //formaPagamentoSelecionada: string;
    formaPagamento: any;
    onChangeFormaPagamento: (formaPagamento: string) => void;

    observacao: string;
    onChangeObservacao: (observacao: string) => void;

    //carrinho: ItemCarrinho[];
    onChangeCarrinho: (item: ItemDestaque) => void;
    onChangeQtdItem: (id: string, delta: number) => void;
    onChangeRemoveItem: (id: string) => void;

    vlrTotal: number;

    onSubmit: () => void;
};

const ModalNovoPedidoComponent: React.FC<Props> = (props: Props) => {
    const [searchItensInput, setSearchItensInput] = useState("");

    const itensFiltered = props.itens.filter((item) =>
        item.titulo.toLowerCase()
            .includes(searchItensInput.toLowerCase())
    )

    const renderVlrTotal = () => {
        return props.carrinho.reduce((total: number, itemCarrinho: any) => {
            let totalComplementos = 0;

            if (Array.isArray(itemCarrinho.complementos)) {
                totalComplementos += itemCarrinho.complementos.reduce(
                    (soma: number, complemento: any) =>
                        soma + Number(complemento.vlrUnitario),
                    0
                );
            }

            if (Array.isArray(itemCarrinho.complementosEspecificos)) {
                totalComplementos += itemCarrinho.complementosEspecificos.reduce(
                    (soma: number, complemento: any) =>
                        soma + Number(complemento.vlrUnitario),
                    0
                );
            }

            const valorUnitario = Number(itemCarrinho.vlrUnitario) + totalComplementos;

            return total + (valorUnitario * itemCarrinho.qtd);

        }, 0);
        //return props.vlrTotal;
    }

    return (
        <Dialog fullScreen open={props.open}
            onClose={props.onClose}
            TransitionComponent={Transition}>
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    height: "100%"
                }}
            >
                {/* ESQUERDA - CATEGORIAS */}
                <CategoriaComponent
                    categoria={props.categoria}
                    categorias={props.categorias}
                    onChangeCategoria={(categoria: string) => props.onChangeCategoria(categoria)}
                />

                {/* CENTRO - PRODUTOS */}
                <ProdutosComponent
                    itens={itensFiltered}
                    searchItens={searchItensInput}
                    onChangeSearchItens={(value: string) => setSearchItensInput(value)}
                    onChangeCarrinho={(item: ItemDestaque) => props.onChangeCarrinho(item)}
                />

                {/* DIREITA - PEDIDO */}
                <InfoPedidoComponent
                    onClose={props.onClose}

                    nomeCliente={props.nomeCliente}
                    onChangeNomeCliente={(nome: string) => props.onChangeNomeCliente(nome)}

                    telefoneCliente={props.telefoneCliente}
                    dadosUsuariosCadastrados={props.dadosUsuariosCadastrados}
                    dadosUsuarioSelecionado={props.dadosUsuarioSelecionado}
                    onChangeUserData={(usuario: Usuario) => props.onChangeUserData(usuario)}
                    //onChangeUsuarioSelecionado={(usuario: Usuario) => props.onChangeUsuarioSelecionado(usuario)}
                    onChangeTelefone={(telefone: string) => props.onChangeTelefone(telefone)}

                    onChangeEndereco={(endereco: UsuarioEnderecos) => props.onChangeEndereco(endereco)}

                    tipo={props.tipo}
                    onChangeTipoPedido={(tipo: string) => props.onChangeTipoPedido(tipo)}

                    pedidoPara={props.pedidoPara}

                    formasPagamento={props.formasPagamento}
                    formaPagamento={props.formaPagamento}
                    //formaPagamentoSelecionada={props.formaPagamentoSelecionada}
                    onChangeFormaPagamento={(formaPagamento: any) => props.onChangeFormaPagamento(formaPagamento)}

                    observacao={props.observacao}
                    onChangeObservacao={(observacao: string) => props.onChangeObservacao(observacao)}

                    carrinho={props.carrinho}
                    onChangeCarrinho={(item: ItemDestaque) => props.onChangeCarrinho(item)}
                    onChangeQtdItem={(id: string, delta: number) => props.onChangeQtdItem(id, delta)}
                    onChangeRemoveItem={(id: string) => props.onChangeRemoveItem(id)}

                    vlrTotal={renderVlrTotal()}
                    onSubmit={() => props.onSubmit()}
                />
            </BoxComponent>
        </Dialog>
    );
};

export default ModalNovoPedidoComponent;